<template>
  <a-menu
    v-model="langMenu"
    offset-y
    close-on-content-click
    dense
    nudge-bottom="2"
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom :disabled="hideTooltip">
        <template v-slot:activator="{ on: tooltip }">
          <a-btn
            class="mr-5"
            text
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
          >
            <v-icon class="mr-2" size="20" color="neutralGray"
              >mdi-translate</v-icon
            >
            {{ selectedLocale.text }}
            <v-icon v-if="langMenu" class="ml-3" color="neutralGray"
              >mdi-chevron-up</v-icon
            >
            <v-icon v-else class="ml-3" color="neutralGray"
              >mdi-chevron-down</v-icon
            >
          </a-btn>
        </template>
        <span>{{ $t("ChangeLang") }}</span>
      </v-tooltip>
    </template>
    <v-list dense>
      <v-list-item-group :value="listSelection">
        <v-list-item
          v-for="(lang, index) in langs"
          :key="index"
          @click="setLang(lang)"
          :value="lang.value"
        >
          <v-list-item-title>{{ lang.text }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </a-menu>
</template>

<script>
import ABtn from "../../wrapper-component/ABtn.vue";
import AMenu from "../../wrapper-component/AMenu.vue";
export default {
  components: { ABtn, AMenu },
  name: "LanguageSelector",
  data() {
    return {
      hideTooltip: false,
      langMenu: false,
      selectedLocale: {
          value: "ja",
          text: "日本語",
          iconSrc: require("../../assets/images/JP.png"),
      },
      langs: [
        {
          value: "en",
          text: "English",
          iconSrc: require("../../assets/images/EngUS.png"),
        },
        {
          value: "ja",
          text: "日本語",
          iconSrc: require("../../assets/images/JP.png"),
        },
      ],
    };
  },
  watch: {
    langMenu(value) {
      if(value) {
        this.hideTooltip = true;
      }
      else {
        this.hideTooltip = false;
      }
    }
  },
  mounted() {
    const temp = localStorage.getItem("SelectedLocale#" + this.tenantId);
    if (temp) {
      this.selectedLocale = JSON.parse(temp);
    }
    //this.$i18n.locale = this.selectedLocale.value;
   this.setLang(this.selectedLocale);
   window.addEventListener('storage', this.handleStorageChange);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange);
  },
  computed: {
    tenantId() {
      return sessionStorage.getItem("tenantId") || localStorage.getItem("tenantId");
    },
    listSelection() {
      return this.$i18n.locale;
    },
  },
  methods: {
    setLang,
    handleStorageChange(event) {
      if (event.key === 'SelectedLocale#' + this.tenantId && event.newValue !== event.oldValue) {
        this.selectedLocale = JSON.parse(event.newValue);
        this.$i18n.locale = JSON.parse(event.newValue)?.value;
      }
    }
  },
};

function setLang(lang) {
  if (this.$i18n.locale !== lang.value) {
    this.selectedLocale = Object.assign({}, lang);
    const loc = JSON.stringify(this.selectedLocale);
    const tenant = sessionStorage.getItem("tenantId");
    localStorage.setItem("SelectedLocale#" + tenant, loc);
    this.$i18n.locale = lang.value;
  }    
}
</script>

<style>
</style>